import * as Option from './option';
import * as Selections from './selections';
/**
 * Constructs ProductSelectionsByPart from a configurator definition and selections.
 * The configurator definition is used to define the parts.
 * The product property from each part is used to fetch the productId from the selections.
 *
 * Throws Error if product property is not found in selections.
 *
 * The returned Option is made up as such:
 *     name: productProperty
 *     value: productId
 */
export const fromConfiguratorAndSelections = (configurator, selections) => {
    const productPropertyNamePerPart = Object.entries(configurator.partsMap).map(([partId, { productProperty }]) => {
        const value = Selections.getByName(selections, productProperty);
        // TODO error handling
        if (value === undefined /** be careful - null is a valid and expected value!! */) {
            throw Error(`Selections does not include product property - this should never happen`);
        }
        return [
            partId,
            Option.create({
                name: productProperty,
                value,
            }),
        ];
    });
    return Object.fromEntries(productPropertyNamePerPart);
};
/**
 * For conspiration we make up the product property, and we call the part 'adjust'
 * This is quite tied to how Stella works, but it's placed here centrally for convenience.
 */
export const forConspiration = (productId) => ({
    adjust: Option.create({
        name: 'Product',
        value: productId,
    }),
});
export const includes = (selections, partName, id) => {
    const option = selections[partName];
    if (!option) {
        return false;
    }
    return Option.value(option) === id;
};
